<template>
  <vb-icon :name="icon" :color="color" :size="size" />
</template>

<script>
import { is_child, is_infant } from '@alpitour/utilities';

export default {
  name: 'passenger-icon',
  props: {
    passenger: {
      type: Object,
      required: true,
    },
    color: {
      type: String,
      default: '#000',
    },
    size: {
      type: Number,
      default: 18,
    },
  },
  computed: {
    icon() {
      if (is_infant(this.passenger)) return 'infant';
      if (is_child(this.passenger)) return 'child';
      return 'user';
    },
  },
};
</script>
